import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { configuration } from '../../../core/configuration';
import { PublicMetadataEntity } from '../../domain/public-metadata.entity';

export enum PublicMetadataFormControls {
	Title = 'title',
	Description = 'description',
}

@Injectable()
export class PublicMetadataForm {
	public form: FormGroup;

	public constructor(protected readonly fb: FormBuilder) {
		this.form = this.form = this.fb.group({
			[PublicMetadataFormControls.Title]: [
				'',
				[
					Validators.required,
					Validators.maxLength(configuration.maxLengthLabel),
				],
			],
			[PublicMetadataFormControls.Description]: [
				'',
				[Validators.maxLength(configuration.maxLengthDescription)],
			],
		});
	}

	public extract(): Partial<PublicMetadataEntity> {
		if (!this.form) {
			throw new Error('no form found');
		}
		const formValues = this.form.value;
		return PublicMetadataEntity.build({
			title: formValues[PublicMetadataFormControls.Title] ?? '',
			description: formValues[PublicMetadataFormControls.Description] ?? '',
		});
	}

	public populate(config: Partial<PublicMetadataEntity> | null): void {
		this.form.patchValue({
			[PublicMetadataFormControls.Title]: config?.title ?? '',
			[PublicMetadataFormControls.Description]: config?.description ?? '',
		});

		this.form.get(PublicMetadataFormControls.Title)?.markAsTouched();
	}
}
